export const HEADER_CLEAR_CONTACT_LENS_DESCRIPTION = {
  title: 'Clear Vision Lenses - Monthly',
  subTitle: 'OWNDAYS',
  description: {
    title: 'Monthly Lenses (6 lenses per box)',
    price: {
      after: 'S$149',
      before: 'S$30',
    },
  },
  bestOffer: {
    discount: '50%',
  },
};

export const HEADER_COLOUR_CONTACT_LENS_DESCRIPTION = {
  title: 'Horoscope Series - Daily',
  subTitle: 'OWNDAYS',
  description: {
    title: 'Daily Lenses (10 lenses per box)',
    price: {
      after: 'S$30',
      before: null,
    },
  },
  bestOffer: {
    discount: '50%',
  },
};

export const USED_POWER = [
  {
    id: '1',
    title: 'John_Doe_1',
    list: [
      {
        powerType: 'SPH',
        left: '-2.00',
        right: '-1.75',
      },
    ],
    startDate: '11/05/2025',
    endDate: '12/11/2024',
  },
  {
    id: '2',
    title: 'John_Doe_2',
    startDate: '11/05/2025',
    endDate: '12/11/2024',
  },
  {
    id: '3',
    title: 'John_Doe_3',
    startDate: '23/02/2025',
    endDate: '24/08/2024',
  },
];

export const LENS_DETAILS = {
  productId: '888888',
  model: 'SNP2015N-2S C1',
  material: 'Acetate ',
  baseWidth: '8.7',
  diameter: '14.2',
};

export const RELATED_PRODUCTS = Array(5)
  .fill(null)
  .map((_, i) => ({
    id: i + 1,
    title: 'OWNDAYS COLOUR',
    subTitle: 'Horoscope series',
    price: {
      after: 'S$40',
      before: null,
    },
    image: '/mock-related-product.webp',
  }));
